import type { SmartpricePlan } from '../../../generated/graphql';

export const isSmartpricePlan = (plan: {
    __typename?: string;
}): plan is SmartpricePlan => plan.__typename === 'SmartpricePlan';
